.noMessages {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;


  &__welcome {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    text-align: center;
    margin-bottom: 12px;

    span {
      color: var(--primary-color);
      letter-spacing: .015em;
      font-family: Eon-office, sans-serif;
      font-size: 32px;
      font-weight: 100;
    }
  }

  &__cards {
    margin: 12px;
  }
}